import { render } from "./problem-view.vue?vue&type=template&id=691d2ed4&scoped=true"
import script from "./problem-view.vue?vue&type=script&lang=js"
export * from "./problem-view.vue?vue&type=script&lang=js"

import "./problem-view.vue?vue&type=style&index=0&id=691d2ed4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-691d2ed4"]])

export default __exports__